function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M23.788 4.382H4.212c-1.085 0-1.962.923-1.962 2.061v15.114c0 1.138.877 2.061 1.962 2.061h19.576c1.085 0 1.962-.923 1.962-2.061V6.443c0-1.138-.877-2.06-1.962-2.06zM4.458 6.443h19.085c.134 0 .245.116.245.258v1.803H4.212V6.701c0-.142.11-.258.245-.258zm19.085 15.114H4.457a.252.252 0 01-.245-.258V14h19.576v7.3c0 .141-.11.257-.245.257zm-13.46-4.294v1.718c0 .283-.22.515-.49.515H6.657a.504.504 0 01-.49-.515v-1.718c0-.283.221-.515.49-.515h2.938c.269 0 .49.232.49.515zm7.834 0v1.718c0 .283-.22.515-.49.515H11.88a.504.504 0 01-.49-.515v-1.718c0-.283.22-.515.49-.515h5.548c.27 0 .49.232.49.515z",
  fill: "#E3F2FD"
});

function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _ref);
}

export default SvgCreditCard;